import ItemOptions from '../item/src/item.options.vue';

ItemOptions.install = function(Vue) {
    Vue.component(ItemOptions.name, ItemOptions);
};

export default ItemOptions;


// WEBPACK FOOTER //
// ./src/components/item-options/index.js